import React, { useState } from "react";
import { FloatButton } from "antd";
import ShareButton from "./ShareButton";
import ColorButton from "./ColorButton";
import CountryButton from "./CountryButton";
import StatsButton from "./StatsButton";
import InfoButton from "./InfoButton";

const Settings = ({color, setColor, showStats, setShowStats, country, setCountry, name}) => {
  return (
    <>
      <FloatButton.Group shape="circle" style={{ insetInlineEnd: 24 }} placement={"left"}>
        <InfoButton />
        <CountryButton country={country} setCountry={setCountry}/>
        <ColorButton color={color} setColor={setColor}/>
        <StatsButton showStats={showStats} setShowStats={setShowStats}/>
        <ShareButton name={name} />
      </FloatButton.Group>
    </>
  );
};

export default Settings;
